import { Typography, Tooltip } from "@mui/material";
import { mdiNoteTextOutline } from "@mdi/js";
import Icon from "@mdi/react";

export default function NoteTooltip({ title }) {
  return (
    <Tooltip title={<Typography fontSize={"1.3em"}>{title}</Typography>} arrow>
      <Icon
        path={mdiNoteTextOutline}
        size={0.6}
        color="rgba(255, 255, 255, 0.5)"
      ></Icon>
    </Tooltip>
  );
}
